import { DateTime } from "luxon";
import type { UserNotification } from "@/domains/notifications/types";

export interface NotificationPayload {
  id?: string;
  title?: string;
  body?: string;
  data?: Record<string, any>;
}

function generateId(source: string): string {
  const timestamp = DateTime.now().toMillis();
  const random = Math.random().toString(36).substring(2, 9);
  return `${source}_${timestamp}_${random}`;
}

export const NotificationTransformer = {
  transform(payload: NotificationPayload, source: "firebase" | "capacitor"): UserNotification {
    const id = payload.id || generateId(source);
    const data = payload.data || {};

    return {
      id,
      salonId: data.salonId || "",
      userId: data.userId || "",
      title: payload.title || "New Notification",
      message: payload.body || "",
      actionText: data.actionText || null,
      actionUrl: data.actionUrl || null,
      schemaKey: data.schemaKey || "GENERAL",
      priority: data.priority || "NORMAL",
      category: data.category || "GENERAL",
      referenceId: data.referenceId || null,
      referenceType: data.referenceType || null,
      isRead: false,
      readAt: null,
      createdAt: DateTime.now().toISO(),
      updatedAt: DateTime.now().toISO(),
      deliveryEvents: [],
    };
  },
};
